export default __webpack_public_path__ + "static/section_4_details_7-7b59b48676a8e32324208d014d4273b7.png";